export default __webpack_public_path__ + "bb5a370.png";